module.exports = __webpack_public_path__ + "static/media/eyeLookOutRight.acc7fcbf.obj";